/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: HelpTab.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  06.02.23 5:39 pm.
 * Last modified: 06.02.23 5:39 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React, { useEffect, useState } from 'react';
import { addBuildHash } from '../../api/helpers';
import { useSettings } from '../../contexts/SettingsContext';
import store from '../../eventStore';
import ISettings from '../../interfaces/ISettings';

const GetHelpUrl = (settings: ISettings) => {
    let htmlFolderPath: string = '';
    const lang = settings.languageCode.toLowerCase();
    if (settings.restrictions?.indexOf('noJackpot') !== -1) {
        htmlFolderPath = 'noJackpot/';
    }

    return `${settings.host}/assets/portal/help/${htmlFolderPath}${lang}.html`;
};

const HelpTab = () => {
    const [settings] = useSettings();
    const [helpContent, setHelpContent] = useState<string>('');
    const version: string = process.env.VERSION ? process.env.VERSION : '';

    useEffect(() => {
        const helpUrl = addBuildHash(GetHelpUrl(settings));

        const request = new XMLHttpRequest();
        request.addEventListener('load', function(): void {
            // the next lines replace the text src="/some/path/to/image.png" to src="http://lobbyHost/some/path/to/image.png?hash=xxxxxx"
            const textArr = this.responseText.split('src="').map((t: string, idx: number) => {
                const s = t.split('"');
                if (idx > 0) {
                    s[0] = addBuildHash(settings.host + s[0]);
                }
                return s.join('"');
            });
            const tmp = textArr.join('src="');
            setHelpContent(tmp.replace(/##VERSION##/g, version));
        });
        request.addEventListener('error', (event): void => {
            store.EXTERNAL_CHANNEL.next({
                event: 'error',
                value: new Error('LOBBY.FETCH_HELP_WINDOW_DATA'),
            });
        });
        request.open('GET', helpUrl);
        request.send();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settings.languageCode, settings.host]);

    return (
        <div className="egt_lobby_settings_help_container">
            <div className="egt_lobby_settings_help_content" dangerouslySetInnerHTML={{ __html: helpContent }} />
        </div>
    );
};

export default HelpTab;
